"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RelatedTopicsList = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _connectors = require("@insided/shared/services/algolia/connectors");

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var _RelatedTopicsSkeleton = require("./RelatedTopicsSkeleton");

var getIconClass = function getIconClass(hit) {
  if (hit.has_answer) {
    return 'icon--checkmark qa-icon-answered';
  }

  if (hit.content_type === 'question') {
    return 'icon--question qa-icon-question';
  }

  return null;
};

var RelatedTopicsList = function RelatedTopicsList(props) {
  var _searchResults$hits;

  var searchResults = props.searchResults,
      searching = props.searching,
      isSearchStalled = props.isSearchStalled,
      topicId = props.topicId,
      widgetTitle = props.widgetTitle,
      totalItemCount = props.totalItemCount;
  var hits = (_searchResults$hits = searchResults === null || searchResults === void 0 ? void 0 : searchResults.hits) !== null && _searchResults$hits !== void 0 ? _searchResults$hits : [];
  var hitsWithoutCurrent = hits.filter(function (hit) {
    return hit.id !== parseInt(topicId, 10);
  }).slice(0, totalItemCount);
  var loading = Boolean(searching || isSearchStalled); // Show skeleton while Algolia is fetching and no hits are available yet to avoid layout shift

  if (loading && !hitsWithoutCurrent.length) {
    return (0, _preact.h)(_RelatedTopicsSkeleton.RelatedTopicsSkeleton, {
      rowCount: totalItemCount,
      widgetTitle: widgetTitle
    });
  } // No related topics found after filtering out the current topic — hide the widget entirely


  if (!hitsWithoutCurrent.length) {
    return null;
  }

  return (0, _preact.h)("div", {
    className: (0, _classnames.default)('box__content', 'widget', 'box__pad', 'widget--related-topics')
  }, Boolean(widgetTitle) && (0, _preact.h)("h3", {
    className: "widget-title related-topics__widget-title"
  }, widgetTitle), (0, _preact.h)("ul", {
    className: "simple-topic-list"
  }, hitsWithoutCurrent.map(function (hit, index) {
    var _hit$topic_url;

    var iconClass = getIconClass(hit);
    return (0, _preact.h)("li", {
      key: index,
      className: "related-topics__topic simple-topic-list--item"
    }, (0, _preact.h)("h4", {
      className: (0, _classnames.default)('h6', 'related-topics__topic-title', 'simple-topic-list--title')
    }, (0, _preact.h)("a", {
      className: "link link--topic",
      href: (0, _absoluteUrlRuntime.resolveUrl)((_hit$topic_url = hit.topic_url) !== null && _hit$topic_url !== void 0 ? _hit$topic_url : hit.url)
    }, _htmlParser.default.stripHtml(hit.title)), Boolean(iconClass) && (0, _preact.h)("span", {
      className: (0, _classnames.default)('icon', 'icon--replace', 'icon--round', iconClass)
    }, "icon")), hit.forum && (0, _preact.h)("a", {
      href: (0, _absoluteUrlRuntime.resolveUrl)("/fid-".concat(hit.forum)),
      className: "text--meta"
    }, hit.forum_title));
  })));
};

exports.RelatedTopicsList = RelatedTopicsList;

var _default = (0, _connectors.connectStateResults)(RelatedTopicsList);

exports.default = _default;